// extracted by mini-css-extract-plugin
export default {"container":"Image_container__Skr80","brandImage":"Image_brandImage__yqVDG","image":"Image_image__Jo8M7","fullImage":"Image_fullImage__lzkqm","date":"Image_date__RHsOO"};